import { render, staticRenderFns } from "./CustomersNews.vue?vue&type=template&id=608ccf05&scoped=true"
import script from "./CustomersNews.vue?vue&type=script&lang=js"
export * from "./CustomersNews.vue?vue&type=script&lang=js"
import style0 from "./CustomersNews.vue?vue&type=style&index=0&id=608ccf05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ccf05",
  null
  
)

export default component.exports